import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { useState, useEffect } from 'react';

const ScreenShotSlider = () => {
    const screenshots = [
        { src: "/assets/images/ScreenShot/dashboardss.png", alt: "Dashboard" },
        { src: "/assets/images/ScreenShot/forwordShipmentss.png", alt: "Shipment" },
        { src: "/assets/images/ScreenShot/trackss.png", alt: "TrackShipment" },
        { src: "/assets/images/ScreenShot/addWarehousess.png", alt: "AddWarehouse" },
        { src: "/assets/images/ScreenShot/viewWarehousess.png", alt: "ViewWarehousess" },
        { src: "/assets/images/ScreenShot/Ndrss.png", alt: "NDR" },
        { src: "/assets/images/ScreenShot/rateCalculatorss.png", alt: "RateCalculator" },
        { src: "/assets/images/ScreenShot/profile.png", alt: "Profile" },
        { src: "/assets/images/ScreenShot/help.png", alt: "Help" },
        { src: "/assets/images/ScreenShot/reports.png", alt: "Reports" },
        { src: "/assets/images/ScreenShot/rateCard.png", alt: "RateCard" },
        { src: "/assets/images/ScreenShot/kycPending.png", alt: "KycPending" },
    ];

    // State to track container height for responsive sizing
    const [sliderHeight, setSliderHeight] = useState('680px');

    // Adjust height based on screen size
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 640) { // Small screens
                setSliderHeight('400px');
            } else if (width < 1024) { // Medium screens
                setSliderHeight('500px');
            } else { // Large screens
                setSliderHeight('680px');
            }
        };

        // Set initial size
        handleResize();
        
        // Update on resize
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        // <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 z-10 bg-white rounded-2xl shadow-xl sm:ml-12 md:ml-12 lg:ml-8 xl:ml-16 2xl:ml-32 overflow-hidden border border-[#eedff0]" style={{ height: sliderHeight }}>
              <div className="w-full max-w-6xl mx-auto z-10 bg-white rounded-2xl shadow-xl overflow-hidden border border-[#eedff0]" style={{ height: sliderHeight }}>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                loop={true}
                className="h-full"
            >
                {screenshots.map((img, index) => (
                    <SwiperSlide key={index}>
                        <div className="flex items-center justify-center h-full">
                            <img
                                src={img.src}
                                alt={img.alt}
                                className="bg-white rounded-2xl w-full h-full object-contain p-2"
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ScreenShotSlider;